import * as yup from 'yup';

import { DEFAULT_REQUIRED_FIELDS } from 'addresses/constants';
import { AddressFields } from 'addresses/enums';
import { addressSchema, contactFieldsSchema } from 'addresses/schemas';

export const updateQuoteAddressSchema = (
  hasContactFields = false,
  requiredAddressFields: AddressFields[] = DEFAULT_REQUIRED_FIELDS
) => {
  const baseContactGroupAddressSchema = yup.object().shape({
    address: addressSchema(true, requiredAddressFields),
    location: yup.object().nullable(),
  });

  if (!hasContactFields) {
    return baseContactGroupAddressSchema;
  }

  return baseContactGroupAddressSchema.shape({
    contact: yup
      .object()
      .shape({
        name: yup.string().nullable(),
        phone: yup.string().nullable(),
        email: yup.string().email().nullable(),
      })
      .nullable(),
    ...contactFieldsSchema(),
  });
};
